export const getNeighbors = state => state.route.neighbors
export const getActiveDrawTool = state => state.route.activeDrawTool
